import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bace654"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary--container mt-[12px] bg-[#DFE5E7] mb-[12px]" }
const _hoisted_2 = { class: "flex flex-nowrap min-w-[830px] h-[56px] w-full bg-System/app_border gap-[1px]" }
const _hoisted_3 = { class: "flex grow bg-white pl-[12px] pr-3" }
const _hoisted_4 = {
  key: 0,
  class: "flex col items-center"
}
const _hoisted_5 = { class: "status--title" }
const _hoisted_6 = { class: "status--title--container" }
const _hoisted_7 = { class: "status--value" }
const _hoisted_8 = { class: "flex grow bg-white pl-[12px] pr-3" }
const _hoisted_9 = {
  key: 0,
  class: "flex col items-center"
}
const _hoisted_10 = { class: "status--title" }
const _hoisted_11 = { class: "status--title--container" }
const _hoisted_12 = { class: "status--value" }
const _hoisted_13 = { class: "flex grow bg-white pl-[12px] pr-3" }
const _hoisted_14 = {
  key: 0,
  class: "flex col items-center"
}
const _hoisted_15 = { class: "status--title" }
const _hoisted_16 = { class: "status--title--container" }
const _hoisted_17 = { class: "status--value" }
const _hoisted_18 = { class: "flex grow bg-white pl-[12px] pr-3" }
const _hoisted_19 = {
  key: 0,
  class: "flex col items-center"
}
const _hoisted_20 = { class: "status--title" }
const _hoisted_21 = { class: "status--title--container" }
const _hoisted_22 = {
  key: 0,
  class: "status--value"
}
const _hoisted_23 = {
  key: 1,
  class: "empty-workload"
}
const _hoisted_24 = { class: "block" }
const _hoisted_25 = { class: "flex grow bg-white pl-[12px] pr-3" }
const _hoisted_26 = {
  key: 0,
  class: "flex col items-center"
}
const _hoisted_27 = { class: "status--title" }
const _hoisted_28 = { class: "status--title--container" }
const _hoisted_29 = {
  key: 0,
  class: "status--value"
}
const _hoisted_30 = {
  key: 1,
  class: "empty-workload"
}
const _hoisted_31 = { class: "block" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { useWorkloadsTableUtils } from '@/views/workloads/workloads.utils';
import { computed, inject, ref, watch } from 'vue';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { NetworkStatus } from '@apollo/client/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'workloadsSummary',
  setup(__props) {

const { secondsToHoursMinutesAndSeconds } = useWorkloadsTableUtils();
const workloadsPageData = inject(IKWorkloadsPageData);
const totalBuilds = ref(0);
const successfulBuilds = ref(0);
const uniqueInitiators = ref(0);
const percentile50 = ref<null | number | undefined>(0);
const percentile90 = ref<null | number | undefined>(0);

const isWorkloadsDataLoaded = computed(() => workloadsPageData?.GQL?.networkStatus?.value === NetworkStatus.ready);
const outOfRangeDataGuard = (value?: number | null) => (workloadsPageData?.isFilterOutOfLicenseRange.value ? 0 : value || 0);

watch(
  () => workloadsPageData?.summary,
  (newValue, oldValue) => {
    if (oldValue !== newValue?.value && newValue && newValue.value) {
      totalBuilds.value = outOfRangeDataGuard(newValue.value.totalBuilds);
      successfulBuilds.value = outOfRangeDataGuard(newValue.value.successfulBuilds);
      uniqueInitiators.value = outOfRangeDataGuard(newValue.value.uniqueInitiators);
      percentile50.value = newValue.value.percentile50 === null ? newValue.value.percentile50 : outOfRangeDataGuard(newValue.value.percentile50);
      percentile90.value = newValue.value.percentile90 === null ? newValue.value.percentile90 : outOfRangeDataGuard(newValue.value.percentile90);
    }
  },
  {
    immediate: true,
    deep: true,
  },
);

const formatNumber = (num: number) => num.toLocaleString('en-US');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "bg-System/app_white border-System/app_border rounded-sm border-[1px] border-solid" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(isWorkloadsDataLoaded))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('workloads.summary.buildTitle')), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(formatNumber(totalBuilds.value)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_unref(isWorkloadsDataLoaded))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('workloads.summary.successBuilds')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(formatNumber(successfulBuilds.value)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_unref(isWorkloadsDataLoaded))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('workloads.summary.totalInitiatorAgents')), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(formatNumber(uniqueInitiators.value)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_unref(isWorkloadsDataLoaded))
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('workloads.summary.50P')), 1),
                  _createElementVNode("div", _hoisted_21, [
                    (percentile50.value || percentile50.value === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(secondsToHoursMinutesAndSeconds)(percentile50.value)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('workloads.summary.emptyPercentile.a')), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('workloads.summary.emptyPercentile.b')), 1)
                        ]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_unref(isWorkloadsDataLoaded))
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('workloads.summary.90P')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    (percentile90.value || percentile90.value === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(secondsToHoursMinutesAndSeconds)(percentile90.value)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('workloads.summary.emptyPercentile.a')), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('workloads.summary.emptyPercentile.b')), 1)
                        ]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})